<template>
  <AppContainer>
    <form
      autocomplete="off"
      @submit.prevent="submitForm"
    >
      <AppCard>
        <TextInput
          v-model.trim="formData.shortName"
          autofocus
          label="Short Name"
          required
          :validation-error="hasValidationError('shortName') ? getValidationError('shortName') : null"
        />

        <TextInput
          v-model.trim="formData.name"
          label="Name"
          required
          :validation-error="hasValidationError('name') ? getValidationError('name') : null"
        />

        <TextInput
          v-model.trim="formData.sortOrder"
          type="number"
          label="Sort Order"
          :validation-error="hasValidationError('sortOrder') ? getValidationError('sortOrder') : null"
        />

        <TextInput
          v-model.trim="formData.referenceUrl"
          label="Framework URL"
          required
          :validation-error="hasValidationError('url') ? getValidationError('url') : null"
        />

        <TextEditorInput
          id="description"
          v-model="formData.description"
          label="Framework description"
          required
          :allow-image-upload="false"
          :validation-error="hasValidationError('description') ? getValidationError('description') : null"
        />

        <template #buttons>
          <ButtonSubmitRow
            :cancel-route="{ name: 'app_framework_list' }"
            :processing="isSubmitting"
          />
        </template>
      </AppCard>
    </form>
  </AppContainer>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { reactive } from 'vue';
import { useRouter } from 'vue-router';

import { AppContainer } from '@/components/app';
import { AppCard } from '@/components/cards';
import { ButtonSubmitRow } from '@/components/buttons';
import { TextEditorInput, TextInput } from '@/components/form-inputs';

import { useFormSubmit } from '@/composables';

const props = defineProps({
  model: {
    type: Object,
    default: () => null,
  },
});

const { submit, isSubmitting, hasValidationError, getValidationError } = useFormSubmit();
const router = useRouter();

const formData = reactive({
  name: props.model?.name || null,
  shortName: props.model?.shortName || null,
  sortOrder: props.model?.sortOrder || null,
  referenceUrl: props.model?.referenceUrl || null,
  description: props.model?.description || null,
});

const submitForm = async () => {
  isSubmitting.value = true;

  const data = new FormData();

  data.append('name', formData.name);
  data.append('shortName', formData.shortName);
  data.append('sortOrder', formData.sortOrder);
  data.append('referenceUrl', formData.referenceUrl);
  data.append('description', formData.description);

  const response = await submit(props.model?.id, data, null, 'frameworks');

  if (response.statusCode === HttpStatusCode.Ok) {
    await router.push({ name: 'app_framework_list' });
  }

  isSubmitting.value = false;
};
</script>
